import React, { useEffect, useState } from 'react';
import { Wallet, TrendingUp, ArrowDown } from 'lucide-react';
import TopBar from '../components/common/TopBar';
import BottomNav from '../components/common/BottomNav';
import LoadingSpinner from '../components/common/LoadingSpinner';
import api from '../services/api';

const Cashback = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/coupons/my/cashback')
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <TopBar title="Cashback" />
        <LoadingSpinner size="lg" />
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background pb-20" data-testid="cashback-page">
      <TopBar title="Cashback" showBack />

      <div className="max-w-md mx-auto p-4 space-y-4">
        <div className="bg-gradient-to-br from-secondary to-primary rounded-2xl p-6 text-white shadow-lg">
          <div className="flex items-center gap-2 mb-2">
            <Wallet className="w-5 h-5" />
            <span className="text-sm text-white/80">Saldo disponível</span>
          </div>
          <p className="font-['Outfit'] text-4xl font-bold">
            R$ {data?.balance?.toFixed(2) || '0.00'}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white rounded-xl border border-border p-3">
            <div className="flex items-center gap-1 text-xs text-secondary mb-1">
              <TrendingUp className="w-3 h-3" />
              Ganhos
            </div>
            <p className="font-bold text-lg">R$ {data?.total_earned?.toFixed(2) || '0.00'}</p>
          </div>
          <div className="bg-white rounded-xl border border-border p-3">
            <div className="flex items-center gap-1 text-xs text-muted-foreground mb-1">
              <ArrowDown className="w-3 h-3" />
              Usado
            </div>
            <p className="font-bold text-lg">R$ {data?.total_spent?.toFixed(2) || '0.00'}</p>
          </div>
        </div>

        <div>
          <h2 className="font-['Outfit'] font-bold text-lg mb-3">Histórico</h2>
          {(!data?.transactions || data.transactions.length === 0) ? (
            <div className="bg-white rounded-xl border border-border p-8 text-center">
              <Wallet className="w-12 h-12 mx-auto text-muted-foreground mb-2" strokeWidth={1.5} />
              <p className="text-muted-foreground">Sem transações ainda</p>
              <p className="text-xs text-muted-foreground mt-1">Faça pedidos para ganhar cashback!</p>
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-border divide-y divide-border">
              {data.transactions.map((t) => (
                <div key={t.id} className="p-3 flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-sm">{t.description}</p>
                    <p className="text-xs text-muted-foreground">
                      {new Date(t.created_at).toLocaleDateString('pt-BR')}
                    </p>
                  </div>
                  <span className={`font-bold ${t.transaction_type === 'earn' ? 'text-secondary' : 'text-destructive'}`}>
                    {t.transaction_type === 'earn' ? '+' : '-'}R$ {t.amount.toFixed(2)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default Cashback;
